import React from 'react';
import { ChevronDown } from 'lucide-react';

export interface NativeSelectOption {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: NativeSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  testid?: string;
  className?: string;
  size?: 'default' | 'sm';
}

/**
 * Select nativo (``<select>``) usato per i filtri Marca/Tipologia/Origine —
 * a differenza di ``SearchableSelect`` (combobox con ricerca, pensato per
 * liste molto lunghe) qui la lista è breve/gestibile e l'utente si aspetta
 * il comportamento standard di un ``<select>`` di sistema.
 */
export function NativeFilterSelect({
  value,
  onChange,
  options,
  placeholder = 'Seleziona...',
  disabled,
  testid,
  className = '',
  size = 'default',
}: Props) {
  const sizeClasses = size === 'sm' ? 'h-9 pl-2.5 pr-7 text-xs' : 'h-11 pl-3 pr-9 text-sm';
  return (
    <div className="relative">
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        data-testid={testid}
        className={`w-full ${sizeClasses} rounded-lg border bg-white font-medium text-foreground appearance-none focus:outline-none focus:ring-2 focus:ring-[hsl(214,58%,41%)] focus:border-transparent uppercase tracking-wide disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer ${className}`}
      >
        <option value="">{placeholder}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <ChevronDown className={`pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground ${size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'}`} />
    </div>
  );
}
